// @module Tavanoteam.BackorderMessage.BackorderMessage
define('Tavanoteam.BackorderMessage.BackorderMessage.View'
,	[
	'tavanoteam_backordermessage_backordermessage.tpl'
	
	,	'Backbone'
	,	'jQuery'
    ,	'underscore'

    ]
, function (
	tavanoteam_backordermessage_backordermessage_tpl

	,	Backbone
	,	jQuery
	,	_ 
	
)
{
    'use strict';

	// @class Tavanoteam.BackorderMessage.BackorderMessage.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_backordermessage_backordermessage_tpl

	,	initialize: function (options) {

		var self = this;
		
		this.container = options.container;
		var cart = this.container.getComponent('Cart');
		
		this.cartItem = [];

		this.elementId = '';
		this.parentEl = '';
		this.parentId = '';

		//Get Cart Lines
		cart.getLines().then(function(lines) {

			_.each(lines, function(item){
				
				var cart_obj = {};

				self.item = item.item;
			
				cart_obj.internalid = item.item.internalid;
				cart_obj.quantity = item.quantity;
				cart_obj.quantityavailable = item.item.extras.quantityavailable;
				cart_obj.isinstock = item.item.extras.isinstock;

				cart_obj.showmessage = true;

				//Show Message?			
				if (item.item.extras.isinstock) {
					if (item.quantity > item.item.extras.quantityavailable) {
						cart_obj.backorderqty = item.quantity - item.item.extras.quantityavailable;
					}
					else {
						cart_obj.showmessage = false;
					}
				}

				else {
					cart_obj.backorderqty = item.quantity;
				}

				self.cartItem.push(cart_obj);

			});

			self.render();

			self.trigger('matchElements');
		});

		//Match Element to its Parent
		this.on('matchElements', function (){

			jQuery('[name="backordermessage-content"]').each(function(index) {

				self.elementId = jQuery(this).attr('data-backordermsg-id');
				self.parentEl = jQuery(this).parents()[1];
				self.parentId = jQuery(self.parentEl).data('backordermsgItemid');

				if (self.elementId != self.parentId) {
					jQuery(this).remove();
				}
						
			});

		});

		}

		//@method getContext @return Tavanoteam.BackorderMessage.BackorderMessage.View.Context
	,	getContext: function getContext()
		{
			//@class Tavanoteam.BackorderMessage.BackorderMessage.View.Context

			return {
				cartItem: this.cartItem
			};
		}
	});
});
